export const enum LoginModalEndpointsKeys {
  LOGIN_MODAL_AEM_URL = 'LOGIN_MODAL_AEM_URL',
  APP_AUTH_CONFIG_JSON = 'APP_AUTH_CONFIG_JSON',
  LOGIN_DASHBOARD_BFF_URL = 'LOGIN_DASHBOARD_BFF_URL',
  LOGIN_CUST_BFF_LOGIN_URL = 'LOGIN_CUST_BFF_LOGIN_URL',
  LOGIN_QUERY_PAGE_BFF_URL = 'LOGIN_QUERY_PAGE_BFF_URL',
  FORGOT_LOGIN_BFF_URL = 'FORGOT_LOGIN_BFF_URL',
  RESET_PASSWORD_EMAIL_LINK = 'RESET_PASSWORD_EMAIL_LINK',
  RESET_PASSWORD = 'RESET_PASSWORD',
  SHOW_RESET_PASSWORD_URL = 'SHOW_RESET_PASSWORD_URL',
  LOGIN_VALIDATE_SQA = 'LOGIN_VALIDATE_SQA',
  LOGIN_SECURITY_QUESTIONS = 'LOGIN_SECURITY_QUESTIONS',
  DASHBOARD_BFF_URL = 'DASHBOARD_BFF_URL',
  ADD_SECURITY_QUESTIONS = 'ADD_SECURITY_QUESTIONS',
  ADD_EMAIL_ADDRESS_URL = 'ADD_EMAIL_ADDRESS_URL',
  COUNTRY_CODES_BFF_URL = 'COUNTRY_CODES_BFF_URL',
  ADDRESS_LINES_BFF_URL = 'ADDRESS_LINES_BFF_URL',
  SAVE_ADD_SECURITY_QUESTIONS = 'SAVE_ADD_SECURITY_QUESTIONS',
  VALIDATE_ADDRESS_BFF_URL = 'VALIDATE_ADDRESS_BFF_URL',
  PERSONALIZATION_ENGINE_URL = 'PERSONALIZATION_ENGINE_URL'
}
